import Vue from "vue";
import Router from "vue-router";
import Top from "@/views/Top.vue";
import Golf from "@/views/Golf.vue";
import MedicalConcierge from "@/views/MedicalConcierge.vue";
import TokyoCalenderClub from "@/views/TokyoCalenderClub.vue";
import PrivateCruising from "@/views/PrivateCruising.vue";
import FreeFood from "@/views/FreeFood.vue";
import FreeStay from "@/views/FreeStay.vue";
import ResortStay from "@/views/ResortStay.vue";
import UpgradePlan from "@/views/UpgradePlan.vue";
import HalfPlan from "@/views/HalfPlan.vue";
import About from "@/views/About.vue";
import PrivateHelicopter from "@/views/PrivateHelicopter.vue";
import PrivateJet from "@/views/PrivateJet.vue";
import Error404 from "@/views/error/Error404.vue";
import Main from "@/views/Main.vue";
import NewsDetail from "@/views/NewsDetail.vue";

// console.log(process.env.VUE_APP_SUBDIRECTORY);

// 各URLのエイリアス取得（サブディレクトリでも各URLで参照できるようにする対応）
function getAlias(path) {
  const sub_directory_env = process.env.VUE_APP_SUBDIRECTORY;
  if (!sub_directory_env) {
    // 環境変数定義が存在しない場合、そのまま返却
    return [path];
  }
  let sub_directory_arr = sub_directory_env.split(";");
  for (let i = 0; i < sub_directory_arr.length; i++) {
    sub_directory_arr[i] = sub_directory_arr[i] + path;
  }
  // console.log(sub_directory_arr);
  return sub_directory_arr;
}

// 各ページのURLを定数定義
const OTHER_PAGE_URL = "/otherPage";
const GOLF_URL = "/golf";
const MEDICAL_CONCIERGE_URL = "/medicalConcierge";
const TOKYO_CALENDAR_CLUB_URL = "/tokyoCalenderClub";
const PRIVATE_CRUISING_URL = "/privateCruising";
const FREE_FOOD_URL = "/freeFood";
const FREE_STAY_URL = "/freeStay";
const UPGRADE_PLAN_URL = "/upgradeplan";
const HALF_PLAN_URL = "/halfplan";
const ABOUT_URL = "/about";
const PRIVATE_HELICOPTER_URL = "/privateHelicopter";
const PRIVATE_JET_URL = "/privateJet";
const REPORT_STAY_URL = "/resortStay";

const NEWS_DETAIL_URL = "/news-detail/:id";
export const BASE_PREMIUM_MOBILITY_URL = "/premium-mobility-club";
export const FREE_FOOD_AFTER_LOGIN_URL = `${BASE_PREMIUM_MOBILITY_URL}/freeFoodAfterLogin`;
export const FREE_STAY_AFTER_LOGIN_URL = `${BASE_PREMIUM_MOBILITY_URL}/freeStayAfterLogin`;


Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "main",
      alias: getAlias(""),
      component: Main,
      children: [
        {
          path: "/",
          name: "top",
          alias: getAlias(""),
          component: Top,
        },
        {
          // コンテンツ詳細ページ
          path: OTHER_PAGE_URL,
          name: "CrpgOtherPage",
          alias: getAlias(OTHER_PAGE_URL),
          component: () => import("@/views/OtherPage.vue")
        },
        {
          path: GOLF_URL,
          name: "golf",
          alias: getAlias(GOLF_URL),
          component: Golf,
        },
        {
          path: MEDICAL_CONCIERGE_URL,
          name: "medicalConcierge",
          alias: getAlias(MEDICAL_CONCIERGE_URL),
          component: MedicalConcierge,
        },
        {
          path: TOKYO_CALENDAR_CLUB_URL,
          name: "tokyoCalenderClub",
          alias: getAlias(TOKYO_CALENDAR_CLUB_URL),
          component: TokyoCalenderClub,
        },
        {
          path: PRIVATE_CRUISING_URL,
          name: "privateCruising",
          alias: getAlias(PRIVATE_CRUISING_URL),
          component: PrivateCruising,
        },
        {
          path: FREE_FOOD_URL,
          name: "freeFood",
          alias: getAlias(FREE_FOOD_URL),
          component: FreeFood,
        },
        {
          path: FREE_STAY_URL,
          name: "freeStay",
          alias: getAlias(FREE_STAY_URL),
          component: FreeStay,
        },
        {
          path: UPGRADE_PLAN_URL,
          name: "upgradeplan",
          alias: getAlias(UPGRADE_PLAN_URL),
          component: UpgradePlan,
        },
        {
          path: HALF_PLAN_URL,
          name: "halfplan",
          alias: getAlias(HALF_PLAN_URL),
          component: HalfPlan,
        },
        {
          path: ABOUT_URL,
          name: "about",
          alias: getAlias(ABOUT_URL),
          component: About,
        },
        {
          path: PRIVATE_HELICOPTER_URL,
          name: "privateHelicopter",
          alias: getAlias(PRIVATE_HELICOPTER_URL),
          component: PrivateHelicopter,
        },
        {
          path: PRIVATE_JET_URL,
          name: "privateJet",
          alias: getAlias(PRIVATE_JET_URL),
          component: PrivateJet,
        },
        {
          path: NEWS_DETAIL_URL,
          name: "newsDetail",
          alias: getAlias(NEWS_DETAIL_URL),
          component: NewsDetail,
        },
        {
          path: FREE_FOOD_AFTER_LOGIN_URL,
          name: "freeFood",
          component: FreeFood,
        },
        {
          path: FREE_STAY_AFTER_LOGIN_URL,
          name: "freeStay",
          component: FreeStay,
        },
        {
          path: REPORT_STAY_URL,
          name: "resortStay",
          component: ResortStay,
        },
      ],
    },
    {
      path: "/404",
      name: "error404",
      component: Error404,
    },
    {
      path: "/*",
      redirect: { name: "error404" },
    },
  ],
});
